import { DESKTOP_DYNAMIC_TEMPLATE_CONFIG } from "../desktop-dynamic-template/desktop-dynamic-template-config";
import { defaultData } from "./default-data";

export const REMOTE_WORK_TEMPLATE_CONFIG = {
  ...DESKTOP_DYNAMIC_TEMPLATE_CONFIG,
  defaultData
};
